import { Theme } from '@aws-amplify/ui-react';

export const theme: Theme = {
  name: 'aslan-brand-theme',
  tokens: {
    colors: {
      brand: {
        primary: {
          10: { value: '#F7F5FD' },
          20: { value: '#EEEBF9' },
          40: { value: '#9A7EEA' },
          80: { value: '#5934C4' }, // Aslan Purple
          90: { value: '#392080' }, // Dark Accent
          100: { value: '#2A175C' },
        },
      },
      neutral: {
        40: { value: '#BAC2CE' },
      },
      font: {
        primary: { value: '#1a1a1a' }, // Black text
      },
    },
    fonts: {
      default: {
        variable: { value: "'Montserrat', sans-serif" },
        static: { value: "'Montserrat', sans-serif" },
      },
    },
  },
  // Overrides sections has been removed to reset component styles.
};
